import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransactionalEmailsRoutingModule } from './transactional-emails-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TransactionalEmailsRoutingModule
  ]
})
export class TransactionalEmailsModule { }
